import { useParams } from 'react-router-dom';
import ChannelOverviewContainer from '../components/containers/channel/channel-overview.container';
import ChannelContainer from '../components/containers/channel/channel.container';
import ChannelsHeader from '../components/header/channels.header';
import Header from '../components/header/default.header';
import InfoLayout from '../components/layouts/info.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import { useInfoControl } from '../hooks/useInfoControl';

import { channels } from '../test.data';

type Props = {};

// Notes: - fails to find the channel on refresh because id
// is constantly changing due to how channels are generated

export default function Channel(props: Props) {
  const [showInfo, current, trigger, reset] = useInfoControl<{ id: string }>();

  const params = useParams();

  const channel = channels.find((channel) => channel.id === params.channelId);

  return (
    <MainLayout layout="alt">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          <InfoLayout close={reset} showInfo={showInfo}>
            <InfoLayout.Content>
              <div className="flex flex-row">
                <div className="mobile:hidden tablet-lg:block tablet-lg:w-[300px] h-max sticky top-0">
                  <ChannelsHeader />
                </div>
                <div className="flex mobile:w-full tablet-lg:w-[calc(100%-300px)] sticky top-0">
                  <ChannelContainer trigger={trigger} channel={channel} />
                </div>
              </div>
            </InfoLayout.Content>
            <InfoLayout.Aside>
              {current && (
                <ChannelOverviewContainer
                  channelId={current.id}
                  close={reset}
                />
              )}
            </InfoLayout.Aside>
          </InfoLayout>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}
